import { z } from 'zod';

export const websiteConfigSchema = z.object({
  aboutUsContent: z.string().nullable().default(null),
  domainName: z.string().describe('May be subdomain'),
  facebookUrl: z.string().nullable().default(null),
  instagramUrl: z.string().nullable().default(null),

  // Images
  aboutUsImageId: z.string().nullable().default(null),
  aboutUsImageUrl: z.string().nullable().default(null),
  bannerImageId: z.string().nullable().default(null),
  bannerImageUrl: z.string().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  restaurantId: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type WebsiteConfig = z.output<typeof websiteConfigSchema>;

/** Strict schema */
export const websiteConfigStrictSchema = websiteConfigSchema.extend({
  facebookUrl: z.url().nullable(),
  instagramUrl: z.url().nullable(),
});

/** Convex schema */
export const websiteConfigCvxSchema = websiteConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  restaurantId: z.string(),
  updatedAt: z.number(),
});
export type WebsiteConfigCvx = z.output<typeof websiteConfigCvxSchema>;
